module.exports = __webpack_public_path__ + "img/logoSunDrive.53d44fbf.png";